import React, { useState } from "react";
import { Row, Col, FormGroup, Label, Input, Button } from "reactstrap";
import { Filter, X } from "react-feather";

/**
 * ProjectsFilter - Filter component for projects view
 * @param {Object} filters - Current filter values
 * @param {Function} onApplyFilters - Callback to apply filters
 * @param {Function} onClearFilters - Callback to clear filters
 */
const ProjectsFilter = ({ filters, onApplyFilters, onClearFilters }) => {
  const [localFilters, setLocalFilters] = useState(filters);

  const handleChange = (field, value) => {
    setLocalFilters((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleApply = () => {
    onApplyFilters(localFilters);
  };

  const handleClear = () => {
    const defaultFilters = { name: "", status: null, sort: "-createdAt" };
    setLocalFilters(defaultFilters);
    onClearFilters();
  };

  return (
    <div className="projects-filter mb-3 p-3 border rounded">
      <h6 className="mb-3">
        <Filter size={16} className="me-2" />
        Filters
      </h6>
      <Row>
        <Col md="4">
          <FormGroup>
            <Label for="filterName">Project Name</Label>
            <Input
              id="filterName"
              type="text"
              placeholder="Search by project name..."
              value={localFilters.name}
              onChange={(e) => handleChange("name", e.target.value)}
            />
          </FormGroup>
        </Col>
        <Col md="3">
          <FormGroup>
            <Label for="filterStatus">Status</Label>
            <Input
              id="filterStatus"
              type="select"
              value={localFilters.status || ""}
              onChange={(e) => handleChange("status", e.target.value || null)}
            >
              <option value="">All</option>
              <option value="ACTIVE">Active</option>
              <option value="COMPLETED">Completed</option>
              <option value="ON_HOLD">On Hold</option>
              <option value="CANCELLED">Cancelled</option>
            </Input>
          </FormGroup>
        </Col>
        <Col md="4">
          <FormGroup>
            <Label for="filterSort">Sort By</Label>
            <Input
              id="filterSort"
              type="select"
              value={localFilters.sort}
              onChange={(e) => handleChange("sort", e.target.value)}
            >
              <option value="-createdAt">Newest First</option>
              <option value="createdAt">Oldest First</option>
              <option value="name">Name A-Z</option>
              <option value="-name">Name Z-A</option>
            </Input>
          </FormGroup>
        </Col>
        <Col md="1" className="d-flex align-items-end">
          <FormGroup>
            <Button
              color="primary"
              onClick={handleApply}
              className="w-100"
              title="Apply Filters"
            >
              <Filter size={14} />
            </Button>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col>
          <Button
            color="secondary"
            size="sm"
            outline
            onClick={handleClear}
          >
            <X size={14} className="me-1" />
            Clear Filters
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default ProjectsFilter;
